<template>
  <div id="app">
    <div>
      <slideout-panel></slideout-panel>
      <Header />
      <div class="container">
        <div class="row d-flex min-vh-100">
          <div class="col-md-3 d-none d-md-block" v-if="isLoggedIn && isRoleSupplier">
            <Sidebar />
          </div>
          <div class="col-md-9" :class="{ 'offset-md-4': !isLoggedIn || !isRoleSupplier }">
            <div class="wrapper h-100">
              <transition :name="transitionName" mode="out-in">
                <router-view />
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Header from '@/views/layouts/Header.vue';
import Sidebar from '@/views/layouts/Sidebar.vue';

export default {
  components: { Header, Sidebar },
  data() {
    return {
      transitionName: 'slide-right',
    };
  },
  created() {
    this.$router.beforeEach((to, from, next) => {
      const toDepth = to.path.split('/').length;
      const fromDepth = from.path.split('/').length;
      let transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left';

      this.transitionName = transitionName;

      next();
    });
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'auth/isLoggedIn',
      isRoleSupplier: 'auth/isRoleSupplier',
    }),
  },
};
</script>

<style>
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.3s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translate(-2em, 0);
}
</style>
